import React from 'react';

import ThemeWrapper from '../components/styles/ThemeWrapper/index.js';
import ErrorBoundary from '../components/errors/ErrorBoundary';
import Flexbox from 'flexbox-react';
import { Provider } from 'mobx-react';
import { Icon, Dialog, InputGroup } from "@blueprintjs/core";
import ScrollableDropdown from '../components/shared/ScrollableDropdown.jsx';
import axios from 'axios';
import Cookies from 'js-cookie';
import ToastStore from "../stores/ToastStore.js";
import AssignEmployeesTable from '../components/feedback_360_settings/AssignEmployeeTable';
import '../components/feedback_360_settings/AssignEmpView.css';
import { FilledButton, OutlinedButton } from '../components/buttons-20250224T111359Z-001/buttons';
import CKEditorField from '../components/shared/CKEditorField.js';


export default class AssignEmployeesView extends React.Component {
  state = {
    goalCycleList: [],
    participants: [],
    allEployees: [],
    selectedEmployees: [],
    availableEmployees: [],
    isAllEmployeesSelected: false,
    selectedTimeframe: {},
    currentPage: 1,
    perPage: 10,
    totalParticipants: 0,
    totalParticipantPages: 0,

    isAddEmployeeDialogOpen: false,
    isSendingReminder: {},
    reminderCooldown: {},
    isReviewerDialogOpen: false,
    reviewerDialogType: null, // "peer" | "direct_report" | "all"
    selectedParticipant: null,
    selectedReviewers: [],
    selectedRater: null,
    newlySelectedReviewers: [],
    isLoading: false,
    reviewerSearch: "",
    reviewerSearchResults: [],
    isReviewerSearchLoading: false,


    isReminderEditorOpen: false,
    reminderEmployee: null,
    activeReminderTab: 'self',
    reminderSubjects: {
      self: 'Reminder: Complete Your 360 Feedback',
      allMembers: 'Reminder: Complete 360 Feedback for All Members',
    },
    reminderMessages: {
      self: '',
      allMembers: '',
    },
  };

  componentDidMount() {
    this.getAllGoalCycleList();
    this.getAllEployees();

  }

  componentWillUnmount() {
    clearTimeout(this.reviewerSearchTimeout);
  }

  getAllGoalCycleList = () => {
    this.setState({ isLoadingCycles: true });

    return new Promise((resolve, reject) => {
      axios.get(`${Cookies.get("apiEnv")}/goal_settings/goal_cycle_list`)
        .then(response => {
          const goalCycleList = response.data || [];

          if (goalCycleList.length > 0) {
            this.setState(
              {
                goalCycleList,
                selectedTimeframe: goalCycleList[0],
                isLoadingCycles: false,
              },
              () => {
                this.fetchParticipants();
              }
            );

            resolve();
          } else {
            this.setState(
              {
                goalCycleList: [],
                selectedTimeframe: {},
                isLoadingCycles: false,
              },
              resolve
            );
          }
        })
        .catch(error => {
          this.setState({
            error: "Failed to load",
            isLoadingCycles: false,
          });

          reject(error);
        });
    });
  };


  fetchParticipants = (page = this.state.currentPage, perPage = this.state.perPage) => {
    const { selectedTimeframe } = this.state;
    if (!selectedTimeframe?.id) {
      return;
    }

    this.setState({ isLoading: true });

    axios.post(`${Cookies.get("apiEnv")}/rater/feedback_assignment_lists`, {

      goal_setting_id: selectedTimeframe.id,
      page,
      per_page: perPage,

    })
      .then(response => {
        const apiData = response?.data || {};
        const participants = apiData?.data || [];
        const meta = apiData?.meta || {};

        this.setState({
          participants,
          currentPage: meta.page || page,
          perPage: meta.per_page || perPage,
          totalParticipants: meta.total_count || 0,
          totalParticipantPages: meta.total_pages || 0,
          isLoading: false,
        });
      })
      .catch(error => {
        console.error("Failed to fetch participants:", error);

        this.setState({
          participants: [],
          totalParticipants: 0,
          totalParticipantPages: 0,
          isLoading: false,
        });
      });
  };

  getAllEployees = async () => {
    this.setState({ isLoading: true })

    return new Promise((resolve, reject) => {
      axios.get(`${Cookies.get("apiEnv")}/goals/employee`)
        .then(response => {
          const allEployees = response.data || [];
          this.setState({
            allEployees: allEployees,
            availableEmployees: allEployees,
            isLoading: false,
          });

        })
        .catch(error => {
          this.setState({ error: "Failed to load", isLoading: false });
          reject(error);
        });
    })
  }

  handleParticipantsPageChange = (pageNumber) => {
    this.setState({ currentPage: pageNumber, },
      () => {
        this.fetchParticipants(pageNumber, this.state.perPage);
      }
    );
  };

  handlePerPageChange = (event) => {
    const perPage = parseInt(event.target.value, 10) || 10;
    this.setState({ perPage, currentPage: 1, },
      () => {
        this.fetchParticipants(1, perPage);
      }
    );
  };

  handleSelectGoalCycle = (cycle) => {
    this.setState({ selectedTimeframe: cycle, currentPage: 1, },
      () => {
        this.fetchParticipants(1, this.state.perPage);
      }
    );
  };

  getRaterColumns = () => {
    const { participants } = this.state;
    const raters = [];

    participants.forEach(participant => {
      (participant.raters || []).forEach(rater => {
        if (!raters.some(item => item.id === rater.id)) {
          raters.push({
            id: rater.id,
            title: rater.title,
          });
        }
      });
    });

    return raters;
  };

  //Add Participants functions
  handleAddPartcipants = async () => {
    const { selectedEmployees, selectedTimeframe, isAllEmployeesSelected, availableEmployees, } = this.state;

    const employees = isAllEmployeesSelected ? availableEmployees : selectedEmployees;

    if (!employees.length) { return; }
    if (!selectedTimeframe?.id) { return; }

    const payload = {
      user_id: employees.map((employee) => employee.id),
      goal_setting_id: selectedTimeframe.id,
    };

    try {
      this.setState({ isLoading: true });
      await axios.post(`${Cookies.get("apiEnv")}/rater/add_employee_for_360_feedback`, payload);
      // Close dialog and clear selection
      this.setState({
        isAddEmployeeDialogOpen: false,
        selectedEmployees: [],
        isAllEmployeesSelected: false,
        isLoading: false,
      });

      ToastStore.showToast("Added Successfully", "succes");

      // Refresh participant list
      this.fetchParticipants();
    } catch (error) {
      const errorMsg = error.response.data.error || "Something went wrong";
      this.setState({ isLoading: false, });
      ToastStore.showToast(errorMsg, "danger")

    }
  };

  handleOpenAddEmployeeDialog = () => {
    this.setState({
      isAddEmployeeDialogOpen: true,
      selectedEmployees: [],
      isAllEmployeesSelected: false,
    });
  };

  handleCloseAddEmployeeDialog = () => {
    this.setState({
      isAddEmployeeDialogOpen: false,
      selectedEmployees: [],
      isAllEmployeesSelected: false,
    });
  };

  handleSelectEmployee = (employee) => {
    const { availableEmployees, selectedEmployees } = this.state;

    if (employee.id === "ALL") {
      this.setState({
        isAllEmployeesSelected: true,
        selectedEmployees: availableEmployees,
      });
      return;
    }

    const exists = selectedEmployees.find(
      (emp) => emp.id === employee.id
    );

    if (!exists) {
      this.setState({
        isAllEmployeesSelected: false,
        selectedEmployees: [
          ...selectedEmployees,
          employee,
        ],
      });
    }
  };

  handleRemoveEmployee = (employeeId) => {
    this.setState((prevState) => ({
      selectedEmployees:
        prevState.selectedEmployees.filter(
          (employee) => employee.id !== employeeId
        ),
      isAllEmployeesSelected: false,
    }));
  };

  handleClearSelectedEmployees = () => {
    this.setState({
      selectedEmployees: [],
      isAllEmployeesSelected: false,
    });
  };

  handleOpenReviewerDialog = (employee, rater) => {
    if (!employee?.id || !rater?.id) {
      return;
    }

    const selectedReviewers = rater.assignees || [];

    this.setState({
      isReviewerDialogOpen: true,
      selectedParticipant: employee,
      selectedRater: rater,

      selectedReviewers,
      newlySelectedReviewers: [],

      reviewerSearch: "",
      reviewerSearchResults: this.state.availableEmployees,
      isReviewerSearchLoading: false,
    });
  };
  handleCloseReviewerDialog = () => {
    clearTimeout(this.reviewerSearchTimeout);

    this.setState({
      isReviewerDialogOpen: false,
      selectedParticipant: null,
      selectedRater: null,
      selectedReviewers: [],
      reviewerSearch: "",
      reviewerSearchResults: [],
      newlySelectedReviewers: [],
      isReviewerSearchLoading: false,
    });
  };


  handleReviewerSelection = (employee) => {
    this.setState((prevState) => {
      const { selectedReviewers, newlySelectedReviewers } = prevState;

      const isExistingReviewer = selectedReviewers.some(
        (reviewer) => reviewer.id === employee.id
      );
      const isNewlySelected = newlySelectedReviewers.some(
        (reviewer) => reviewer.id === employee.id
      );

      // If it was selected during this session,
      // clicking again removes it.
      if (isNewlySelected) {
        return {
          selectedReviewers: selectedReviewers.filter(
            (reviewer) => reviewer.id !== employee.id
          ),
          newlySelectedReviewers: newlySelectedReviewers.filter(
            (reviewer) => reviewer.id !== employee.id
          ),
        };
      }

      // If it is an existing reviewer, don't allow
      // the normal "add" action to highlight it.
      if (isExistingReviewer) {
        return null;
      }

      // New reviewer
      return {
        selectedReviewers: [...selectedReviewers, employee],
        newlySelectedReviewers: [...newlySelectedReviewers, employee,],
      };
    });
  };

  // handleClearReviewers = () => {
  //   this.setState({ selectedReviewers: [],});
  // };

  handleClearReviewers = () => {
    this.setState({
      selectedReviewers: [],
      newlySelectedReviewers: [],
    });
  };

  handleSaveReviewerAssignment = async () => {
    const {
      selectedParticipant,
      selectedRater,
      selectedReviewers,
      selectedTimeframe,
    } = this.state;

    if (
      !selectedParticipant?.id ||
      !selectedRater?.id ||
      !selectedTimeframe?.id
    ) {
      return;
    }

    const payload = {
      user_id: selectedParticipant.user?.id || selectedParticipant.id,
      goal_setting_id: selectedTimeframe.id,
      rater_id: selectedRater.id,
      assignes: selectedReviewers.map(
        reviewer => reviewer.id
      ),
    };

    try {
      this.setState({ isLoading: true });

      await axios.post(
        `${Cookies.get("apiEnv")}/rater/assign_feedback_employees`,
        payload
      );

      this.setState({
        isReviewerDialogOpen: false,
        selectedParticipant: null,
        selectedRater: null,
        selectedReviewers: [],
        newlySelectedReviewers: [],
        reviewerSearch: "",
        reviewerSearchResults: [],
        isLoading: false,
      });

      this.fetchParticipants();
    } catch (error) {
      console.error("Failed to assign reviewer:", error);
      const errorMsg = error.response.data.error || "Something went wrong";
      ToastStore.showToast(errorMsg, "danger")
      this.setState({
        isLoading: false,
      });
    }
  };


  handleRemoveReviewer = async (employee, reviewer, rater) => {
    if (
      !employee?.id ||
      !reviewer?.id ||
      !rater?.id ||
      !this.state.selectedTimeframe?.id
    ) {
      return;
    }

    const payload = {
      user_id: employee.user?.id || employee.id,
      goal_setting_id: this.state.selectedTimeframe.id,
      rater_id: rater.id,
      assignes_ids: [reviewer.id],
    };

    const previousParticipants = this.state.participants;

    // Optimistically remove reviewer from UI
    const updatedParticipants = this.state.participants.map(
      participant => {
        if (participant.id !== employee.id) {
          return participant;
        }

        return {
          ...participant,
          raters: (participant.raters || []).map(
            participantRater => {
              if (participantRater.id !== rater.id) {
                return participantRater;
              }

              return {
                ...participantRater,
                assignees: (
                  participantRater.assignees || []
                ).filter(
                  assignee => assignee.id !== reviewer.id
                ),
              };
            }
          ),
        };
      }
    );

    this.setState({
      participants: updatedParticipants,
    });

    try {
      await axios.post(
        `${Cookies.get(
          "apiEnv"
        )}/rater/remove_feedback_employees`,
        payload
      );
    } catch (error) {
      console.error(
        "Failed to remove reviewer assignment:",
        error
      );

      // Restore previous data if API fails
      this.setState({
        participants: previousParticipants,
      });
    }
  };

  handleSendReminder = (employee) => {
    const employeeName = employee.user?.full_name || 'there';

    this.setState({
      isReminderEditorOpen: true,
      reminderEmployee: employee,
      activeReminderTab: 'self',
      reminderSubjects: {
        self: 'Reminder: Complete Your 360 Feedback',
        allMembers: 'Reminder: Complete 360 Feedback for All Members',
      },
      reminderMessages: {
        self: `Hi ${employeeName},
  
  This is a friendly reminder to complete your 360 feedback for the current review cycle.
  
  Please submit your feedback at your earliest convenience.
  
  Thank you!`,

        allMembers: `Hi everyone,
  
  This is a friendly reminder to complete your 360 feedback for the current review cycle.
  
  Please submit your feedback at your earliest convenience.
  
  Thank you!`,
      },
    });
  };
  handleConfirmSendReminder = async () => {
    const {
      reminderEmployee,
      activeReminderTab,
      reminderMessages,
      reminderSubjects,
      selectedTimeframe,
      reminderCooldown,
    } = this.state;
  
    const goalSettingId = selectedTimeframe?.id;
    const userId = reminderEmployee?.user?.id;
    const subject = reminderSubjects[activeReminderTab];
    const body = reminderMessages[activeReminderTab];
  
    if (!goalSettingId || !subject?.trim() || !body?.trim()) {
      ToastStore.showToast(
        'Please enter both the email subject and message.',
        'danger'
      );
      return;
    }
  
    if (activeReminderTab === 'self' && !userId) {
      ToastStore.showToast('Employee not found.', 'danger');
      return;
    }
  
    if (activeReminderTab === 'self' && reminderCooldown[userId]) {
      return;
    }
  
    if (activeReminderTab === 'self') {
      this.setState((prevState) => ({
        isSendingReminder: {
          ...prevState.isSendingReminder,
          [userId]: true,
        },
        reminderCooldown: {
          ...prevState.reminderCooldown,
          [userId]: true,
        },
      }));
    } else {
      this.setState({ isSendingAllMembersReminder: true });
    }
  
    try {
      if (activeReminderTab === 'self') {
        await axios.post(
          `${Cookies.get('apiEnv')}/feedback_reports/send_reminder`,
          { subject, body,is_self: true },
          {
            params: {
              goal_setting_id: goalSettingId,
              user_id: userId,
            },
          }
        );
      } else {
        // Replace with your actual All Members API endpoint.
        await axios.post(
          `${Cookies.get('apiEnv')}/feedback_reports/send_reminder`,
          {
            subject, body,
          },
          {params: { goal_setting_id: goalSettingId,
            user_id: userId,}}
        );
      }
  
      ToastStore.showToast('Reminder sent successfully.', 'success');
  
      this.setState({
        isReminderEditorOpen: false,
        reminderEmployee: null,
        reminderMessages: { self: '', allMembers: '' },
        reminderSubjects: { self: '', allMembers: '' },
      });
    } catch (error) {
      ToastStore.showToast('Failed to send reminder.', 'danger');
    } finally {
      this.setState((prevState) => ({
        isSendingReminder: {
          ...prevState.isSendingReminder,
          [userId]: false,
        },
        isSendingAllMembersReminder: false,
      }));
  
      if (activeReminderTab === 'self' && userId) {
        setTimeout(() => {
          this.setState((prevState) => ({
            reminderCooldown: {
              ...prevState.reminderCooldown,
              [userId]: false,
            },
          }));
        }, 5000);
      }
    }
  };
  

  searchEmployees = async (search) => {
    const trimmedSearch = search.trim();

    if (!trimmedSearch) {
      this.setState({
        reviewerSearchResults: this.state.availableEmployees,
        isReviewerSearchLoading: false,
      });
      return;
    }

    this.setState({ isReviewerSearchLoading: true });

    try {
      const res = await axios.get(
        `${Cookies.get("apiEnv")}/goals/employee/`,
        {
          params: {
            search: trimmedSearch,
          },
        }
      );

      const employees = res?.data || [];

      this.setState({
        reviewerSearchResults: employees,
        isReviewerSearchLoading: false,
      });
    } catch (error) {
      console.error("Failed to search employees:", error);

      this.setState({
        reviewerSearchResults: [],
        isReviewerSearchLoading: false,
      });
    }
  };

  handleReviewerSearch = (event) => {
    const search = event.target.value;

    this.setState({
      reviewerSearch: search,
    });

    clearTimeout(this.reviewerSearchTimeout);

    this.reviewerSearchTimeout = setTimeout(() => {
      this.searchEmployees(search);
    }, 300);
  };

  render() {
    const {
      goalCycleList,
      selectedTimeframe,
      participants,
      currentPage,
      perPage,
      totalParticipants,
      totalParticipantPages,
      isLoading,

      selectedEmployees,
      availableEmployees,
      isAllEmployeesSelected,
      isAddEmployeeDialogOpen,
      isReviewerDialogOpen,
      selectedRater,
      reviewerDialogType,
      selectedParticipant, selectedReviewers, reviewerSearch,
      reviewerSearchResults,
      isReviewerSearchLoading,
      newlySelectedReviewers
    } = this.state;


    return (
      <Provider>
        <ThemeWrapper>
          <ErrorBoundary>
            <Flexbox
              flexGrow={1}
              width="100%"
              alignContent="stretch"
              flexDirection="column"
              paddingBottom="0px"
              className="assign-employees-page"

            >
              <Flexbox
                flexGrow={1}
                flexDirection="column"
                className="fixed-width-container"
              >
                {/* Header */}
                <Flexbox
                  justifyContent="space-between"
                  alignItems="center"
                  flexWrap="wrap"
                  gap="16px"
                  marginBottom="16px"
                >
                  <Flexbox flexDirection="column">
                    <h1 className="assign-employees-title">Assign employees</h1>

                    <div className="assign-employees-subtitle">
                      {selectedTimeframe?.title || "Q3 cycle"} review · add subjects
                      and build each person's reviewer set.
                    </div>
                  </Flexbox>

                  <Flexbox flexDirection="row" alignItems="center" >
                    <ScrollableDropdown
                      width={350}
                      label={selectedTimeframe?.title || "Goal Cycle"}
                      items={goalCycleList}
                      getKey={g => g.id}
                      getLabel={g => g.title}
                      enableSearch
                      onSelect={this.handleSelectGoalCycle}
                    />
                    <FilledButton
                      text="Add Employees"
                      onClick={this.handleOpenAddEmployeeDialog}
                      style={{ marginLeft: "10px", flexShrink: 0 }}
                    />
                  </Flexbox>
                </Flexbox>

                <div className="assign-employees-helper">
                  Manager is pulled automatically from the
                  org chart. Peer and direct-report reviewers
                  are nominated here.
                </div>

                <div className="assign-employees-table-wrapper" style={{ height: '100%', marginBottom: '50px' }}>
                  <AssignEmployeesTable
                    participants={participants}
                    raterColumns={this.getRaterColumns()}
                    currentPage={currentPage}
                    perPage={perPage}
                    totalParticipants={totalParticipants}
                    totalParticipantPages={totalParticipantPages}
                    isLoading={isLoading}
                    onPageChange={
                      this.handleParticipantsPageChange
                    }
                    onPerPageChange={
                      this.handlePerPageChange
                    }
                    onAddReviewer={this.handleOpenReviewerDialog}
                    onRemoveReviewer={this.handleRemoveReviewer}
                    onSendReminder={this.handleSendReminder}
                    isSendingReminder={this.state.isSendingReminder}
                    reminderCooldown={this.state.reminderCooldown}
                  />
                </div>
              </Flexbox>
            </Flexbox>

            <Dialog
              portalContainer={document.body}
              style={{ overflow: "visible" }}
              isOpen={isAddEmployeeDialogOpen}
              onClose={this.handleCloseAddEmployeeDialog}
              title="Add Employee"
            >
              <div
                style={{
                  padding: "20px",
                  minWidth: "400px",
                }}
              >
                <p className="bp3-text-muted push-10-b">
                  You are adding employees for the review cycle:{' '}
                  <strong>
                    {selectedTimeframe?.title}
                  </strong>
                </p>

                {/* Employee Dropdown */}
                <div
                  style={{
                    position: "relative",
                    zIndex: 9999,
                  }}
                >
                  <ScrollableDropdown
                    width={300}
                    style={{
                      overflow: "visible",
                    }}
                    label={
                      isAllEmployeesSelected
                        ? "All Employees"
                        : selectedEmployees.length > 0
                          ? `${selectedEmployees.length} selected`
                          : "Select Employee"
                    }
                    items={[
                      {
                        id: "ALL",
                        first_name: "Select",
                        last_name: "All Employees",
                      },
                      ...availableEmployees,
                    ]}
                    getKey={(employee) => employee.id}
                    getLabel={(employee) =>
                      employee.id === "ALL"
                        ? "Select All Employees"
                        : `${employee.first_name} ${employee.last_name}`
                    }
                    onSelect={this.handleSelectEmployee}
                    enableSearch={true}
                  />
                </div>

                {/* Selected Employees */}
                <div style={{ marginTop: "20px" }}>
                  {isAllEmployeesSelected ? (
                    <div className="assign-emp-selected-item">
                      <strong>
                        All Employees Selected
                      </strong>
                    </div>
                  ) : (
                    <>
                      {selectedEmployees.length > 0 && (
                        <strong>
                          Selected Employees:
                        </strong>
                      )}

                      {selectedEmployees.map((employee) => (
                        <div
                          key={employee.id}
                          className="assign-emp-selected-item"
                        >
                          <div className="assign-emp-selected-item-circle">
                            {employee.first_name?.[0]}
                            {employee.last_name?.[0]}
                          </div>

                          <span>
                            {employee.first_name}{' '}
                            {employee.last_name}
                          </span>

                          <Icon icon="cross" size={12} style={{ cursor: "pointer", marginLeft: "auto", }}
                            onClick={() =>
                              this.handleRemoveEmployee(employee.id)
                            }
                          />
                        </div>
                      ))}
                    </>
                  )}
                </div>

                {/* Actions */}
                <Flexbox
                  flexDirection="row"
                  justifyContent="flex-start"
                  alignItems="center"
                  marginTop="20px"
                >
                  <FilledButton
                    text="Save"
                    onClick={this.handleAddPartcipants}
                    style={{
                      marginRight: "10px",
                    }}
                  />

                  {selectedEmployees.length > 0 && (
                    <OutlinedButton
                      text="Clear All"
                      onClick={this.handleClearSelectedEmployees}
                    />
                  )}
                </Flexbox>
              </div>
            </Dialog>

            <Dialog
              portalContainer={document.body}
              isOpen={isReviewerDialogOpen}
              onClose={this.handleCloseReviewerDialog}
              title={
                selectedRater
                  ? `Add ${selectedRater.title}`
                  : "Add Reviewers"
              }
              className="assign-emp-reviewer-dialog"
            >
              <div className="assign-emp-dialog-content">

                {/* Description */}
                <div className="assign-emp-dialog-description">
                  {selectedRater
                    ? `Select employees to add as ${selectedRater.title}.`
                    : "Select employees to add as reviewers."}
                </div>

                {/* Search */}
                <div className="assign-emp-search-wrapper">
                  <InputGroup
                    leftIcon="search"
                    placeholder="Search by name or email..."
                    value={reviewerSearch}
                    onChange={this.handleReviewerSearch}
                    className="assign-emp-search"
                    fill
                  />

                  {reviewerSearch && (
                    <button
                      type="button"
                      className="assign-emp-search-clear"
                      onClick={() => {
                        clearTimeout(this.reviewerSearchTimeout);

                        this.setState({
                          reviewerSearch: "",
                          reviewerSearchResults: this.state.availableEmployees,
                          isReviewerSearchLoading: false,
                        });
                      }}
                    >
                      <Icon
                        icon="cross"
                        size={12}
                      />
                    </button>
                  )}

                  {/* Employee list */}
                  <div className="assign-emp-reviewer-list">
                    {isReviewerSearchLoading ? (
                      <div className="assign-emp-reviewer-empty-state">
                        <div>Searching employees...</div>
                      </div>
                    ) : reviewerSearchResults.length === 0 ? (
                      <div className="assign-emp-reviewer-empty-state">
                        <Icon
                          icon="search"
                          size={24}
                        />

                        <div>No employees found</div>

                        <span>
                          Try searching with a different name or email.
                        </span>
                      </div>
                    ) : (
                      reviewerSearchResults.map((employee) => {
                        const isExistingReviewer =
                          selectedReviewers.some(
                            (reviewer) => reviewer.id === employee.id
                          ) &&
                          !newlySelectedReviewers.some(
                            (reviewer) => reviewer.id === employee.id
                          );

                        const isNewlySelected =
                          newlySelectedReviewers.some(
                            (reviewer) => reviewer.id === employee.id
                          );

                        const initials =
                          `${employee.first_name?.[0] || ""}${employee.last_name?.[0] || ""
                            }`.toUpperCase();

                        return (
                          <div
                            key={employee.id}
                            className={`assign-emp-reviewer-list-item ${isNewlySelected
                              ? "assign-emp-reviewer-list-item-selected"
                              : ""
                              } ${isExistingReviewer
                                ? "assign-emp-reviewer-list-item-disabled"
                                : ""
                              }`}
                            onClick={() => {
                              if (!isExistingReviewer) {
                                this.handleReviewerSelection(employee);
                              }
                            }}
                          >
                            <div className="assign-emp-reviewer-checkbox">
                              <input
                                type="checkbox"
                                checked={isNewlySelected}
                                disabled={isExistingReviewer}
                                onChange={() =>
                                  this.handleReviewerSelection(employee)
                                }
                                onClick={(event) =>
                                  event.stopPropagation()
                                }
                              />
                            </div>

                            <div className="assign-emp-reviewer-avatar-large">
                              {employee.image_file_name ? (
                                <img
                                  src={employee.image_file_name}
                                  alt=""
                                />
                              ) : (
                                initials
                              )}
                            </div>

                            <div className="assign-emp-reviewer-employee-info">
                              <div className="assign-emp-reviewer-employee-name">
                                {employee.first_name}{" "}
                                {employee.last_name}
                              </div>

                              {employee.email && (
                                <div className="assign-emp-reviewer-employee-email">
                                  {employee.email}
                                </div>
                              )}
                            </div>

                            {isExistingReviewer && (
                              <div className="assign-emp-reviewer-already-added">
                                Already added
                              </div>
                            )}

                            {isNewlySelected && (
                              <div className="assign-emp-reviewer-selected-icon">
                                <Icon
                                  icon="tick-circle"
                                  size={18}
                                />
                              </div>
                            )}
                          </div>
                        );
                      })
                    )}
                  </div>
                  {/* Footer */}
                  <div className="assign-emp-dialog-footer">

                    <div className="assign-emp-footer-count">
                      {selectedReviewers.length} selected
                    </div>

                    <div className="assign-emp-footer-actions">

                      <OutlinedButton
                        text="Cancel"
                        onClick={this.handleCloseReviewerDialog}
                      />

                      <FilledButton
                        text="Save"
                        onClick={this.handleSaveReviewerAssignment}
                        style={{
                          marginLeft: "10px",
                        }}
                      />

                    </div>

                  </div>

                </div>
              </div>
            </Dialog>

            <Dialog
  portalContainer={document.body}
  isOpen={this.state.isReminderEditorOpen}
  onClose={() =>
    this.setState({
      isReminderEditorOpen: false,
      reminderEmployee: null,
    })
  }
  title="Send Reminder"
  className="assign-emp-reviewer-dialog"
  style={{ width: '700px' }}
>
  <div className="reminder-dialog-content">
    {/* Recipient information */}
    <p className="reminder-dialog-description">
      {this.state.activeReminderTab === 'self' ? (
        <>
          Send an email to{' '}
          <strong>
            {this.state.reminderEmployee?.user?.full_name ||
              'the employee'}
          </strong>
        </>
      ) : (
        <>
          Send an email to <strong>All Members</strong> of the review cycle.
        </>
      )}
    </p>

    {/* Tabs */}
    <div className="reminder-email-tabs">
      <button
        type="button"
        className={`reminder-email-tab ${
          this.state.activeReminderTab === 'self' ? 'active' : ''
        }`}
        onClick={() => this.setState({ activeReminderTab: 'self' })}
      >
        Email for Self
      </button>

      <button
        type="button"
        className={`reminder-email-tab ${
          this.state.activeReminderTab === 'allMembers' ? 'active' : ''
        }`}
        onClick={() => this.setState({ activeReminderTab: 'allMembers' })}
      >
        Email for All Members
      </button>
    </div>

    {/* Email subject */}
    <div className="reminder-subject-field">
      <label htmlFor="reminder-email-subject">
        Subject <span className="reminder-required">*</span>
      </label>

      <InputGroup
        id="reminder-email-subject"
        placeholder="Enter email subject"
        value={
          this.state.reminderSubjects[
            this.state.activeReminderTab
          ]
        }
        onChange={(event) => {
          const subject = event.target.value;
          const activeTab = this.state.activeReminderTab;

          this.setState((prevState) => ({
            reminderSubjects: {
              ...prevState.reminderSubjects,
              [activeTab]: subject,
            },
          }));
        }}
        fill
      />
    </div>

    {/* Email body */}
    <div className="reminder-message-field">
      <label>
        Email Message <span className="reminder-required">*</span>
      </label>

      <CKEditorField
        key={this.state.activeReminderTab}
        value={
          this.state.reminderMessages[
            this.state.activeReminderTab
          ]
        }
        onChange={(message) => {
          const activeTab = this.state.activeReminderTab;

          this.setState((prevState) => ({
            reminderMessages: {
              ...prevState.reminderMessages,
              [activeTab]: message,
            },
          }));
        }}
      />
    </div>

    {/* Footer */}
    <Flexbox
      flexDirection="row"
      justifyContent="flex-end"
      alignItems="center"
      marginTop="24px"
    >
      <OutlinedButton
        text="Cancel"
        onClick={() =>
          this.setState({
            isReminderEditorOpen: false,
            reminderEmployee: null,
          })
        }
      />

      <FilledButton
        text={
          this.state.activeReminderTab === 'self'
            ? (
                this.state.isSendingReminder[
                  this.state.reminderEmployee?.user?.id
                ]
                  ? 'Sending...'
                  : 'Send Reminder'
              )
            : (
                this.state.isSendingAllMembersReminder
                  ? 'Sending...'
                  : 'Send Reminder'
              )
        }
        onClick={this.handleConfirmSendReminder}
        style={{ marginLeft: '10px' }}
      />
    </Flexbox>
  </div>
</Dialog>
          </ErrorBoundary>
        </ThemeWrapper>
      </Provider>
    );
  }
}